import React, { useEffect, useReducer } from 'react';
import cn from 'classnames';

// REDUX
import { useAppDispatch, useAppSelector } from '@Managers/Redux/Hooks';
import { getInGameHistoryPage, setInGameHistoryPage } from '@Managers/Redux/AppState/AppState';

// CSS
import styles from '@UILayer/UILayer.scss';
import { Button } from '@UILayer/Inputs/Button';

const InGameHistoryPage: React.FC<{}> = ({}) => {
    const [state, setState] = useReducer((state: { open: boolean; url: string }, newState: any) => ({ ...state, ...newState }), {
        open: false,
        url: ''
    });
    const dispatch = useAppDispatch();
    const historyPage = useAppSelector(getInGameHistoryPage);

    function closeHistory() {
        dispatch(setInGameHistoryPage({ active: false, url: '' }));
    }

    useEffect(() => {
        setState({ open: historyPage.active, url: historyPage.url });
    }, [historyPage]);

    return (
        <>
            {state.open && (
                <>
                    <div className={styles.ingame_history_page_container}>
                        <div className={styles.ingame_history_page_header}>
                            <Button
                                id={`ui_button_close_ingame_history_page`}
                                className={cn(styles.ingame_close_history_btn)}
                                onChange={() => closeHistory()}
                            ></Button>
                        </div>
                        <div className={styles.ingame_history_page_iframe}>
                            <iframe src={state.url}></iframe>
                        </div>
                    </div>
                </>
            )}
        </>
    );
};

export default InGameHistoryPage;
